import { Routes } from '@angular/router';
import { HomeComponent } from './modules/home/home.component';
import { UserDetailComponent } from './modules/user-management/user-detail/user-detail.component';
import { GroupDetailComponent } from './modules/groups/group-detail/group-detail.component';
import { CompanyDetailComponent } from './modules/companies/company-detail/company-detail.component';
import { AuthGuard } from './guards/auth.guard';
import { ConnectionDetailComponent } from './modules/connection-home/connection-detail/connection-detail/connection-detail.component';
import { TermsOfUseComponent } from './modules/terms-of-use/terms-of-use.component';

export const routes: Routes = [
  { 
    path: '', 
    redirectTo: 'login',
    pathMatch: 'full'
  },
  { 
    path: 'login', 
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  { 
    path: 'registro', 
    loadChildren: () => import('./modules/registration/registration.module').then(m => m.RegistrationModule)
  },
  { 
    path: 'activar-conta', 
    loadChildren: () => import('./modules/activate-account/activate-account.module').then(m => m.ActivateAccountModule)
  },
  { 
    path: 'recuperar-senha', 
    loadChildren: () => import('./modules/password-recovery/password-recovery.module').then(m => m.PasswordRecoveryModule)
  },
  { 
    path: 'redefinir-senha-proprietario', 
    loadChildren: () => import('./modules/reset-owner-password/reset-owner-password.module').then(m => m.ResetOwnerPasswordModule)
  },
  { 
    path: 'redefinir-senha-convite', 
    loadChildren: () => import('./modules/reset-invited-password/reset-invited-password.module').then(m => m.ResetInvitedPasswordModule)
  },
  { 
    path: 'confirmar-codigo', 
    loadChildren: () => import('./modules/password-recovery-confirmation/password-recovery-confirmation.module').then(m => m.PasswordRecoveryConfirmationModule)
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/home-dashboards/home-dashboards.module').then(m => m.HomeDashboardsModule)
      },
      {
        path: 'terms-of-use',
        component: TermsOfUseComponent,
      },
      {
        path: 'lancamentos',
        loadChildren: () => import('./modules/accounting-entries/accounting-entries.module').then(m => m.AccountingEntriesModule)
      },
      {
        path: 'investimentos',
        loadChildren: () => import('./modules/investments/investments.module').then(m => m.InvestmentsModule)
      },
      {
        path: 'usuarios',
        loadChildren: () => import('./modules/user-management/user.module').then(m => m.UserModule)
      },
      {
        path: 'usuario',
        component: UserDetailComponent,
      },
      {
        path: 'usuario/:id',
        component: UserDetailComponent,
      },
      {
        path: 'agrupadores',
        loadChildren: () => import('./modules/groups/groups.module').then(m => m.GroupsModule)
      },
      {
        path: 'agrupador',
        component: GroupDetailComponent,
      },
      {
        path: 'agrupador/:id',
        component: GroupDetailComponent,
      },
      {
        path: 'empresas',
        loadChildren: () => import('./modules/companies/companies.module').then(m => m.CompaniesModule)
      },
      {
        path: 'empresa',
        component: CompanyDetailComponent,
      },
      {
        path: 'empresa/:id',
        component: CompanyDetailComponent,
      },
      {
        path: 'conexoes',
        loadChildren: () => import('./modules/connection-home/connection-home.module').then(m => m.ConnectionHomeModule)
      },
      {
        path: 'conexao',
        component: ConnectionDetailComponent,
      },
      {
        path: 'conexao/:id',
        component: ConnectionDetailComponent,
      }
    ]
  },
  {
    path: 'integracao-openfinance',
    loadChildren: () => {
      console.log('Loading OpenfinanceIntegrationModule...');
      return import('./modules/openfinance-integration/openfinance-integration.module').then(m => {
        console.log('OpenfinanceIntegrationModule loaded successfully');
        return m.OpenfinanceIntegrationModule;
      });
    }
  }
];